import { render, staticRenderFns } from "./ModalAddRoles.vue?vue&type=template&id=8b163e1e&"
import script from "./ModalAddRoles.vue?vue&type=script&lang=js&"
export * from "./ModalAddRoles.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddRoles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports